module.exports = __webpack_public_path__ + "media/assets/images/tour/4_Tour_2-a64721e38bd3da8951ddcba2bb8e696f.png";